<template>
  <button
    type="button"
    v-bind:style="{ width: imageWidth + 'px', height: imageHeight + 'px' }"
    v-on:click="toggleZoom"
  >
    <frame-image :pose="pose" class="zoom-image__frame" />
    <zoom-image :pose="pose" :src="src" :alt="alt" class="zoom-image__img" />
  </button>
</template>

<script>
import posed from 'vue-pose';

const transition = {
  duration: 400,
  ease: [0.08, 0.69, 0.2, 0.99],
};

export default {
  props: ['imageWidth', 'imageHeight', 'src', 'alt'],
  data: () => ({
    isZoomed: false,
  }),

  methods: {
    zoomIn() {
      window.addEventListener('scroll', this.zoomOut);
      this.isZoomed = true;
    },
    zoomOut() {
      window.removeEventListener('scroll', this.zoomOut);
      this.isZoomed = false;
    },
  },
  computed: {
    pose() {
      return this.isZoomed ? 'zoomedIn' : 'zoomedOut';
    },
    toggleZoom() {
      return this.isZoomed ? this.zoomOut : this.zoomIn;
    },
  },
  components: {
    FrameImage: posed.div({
      zoomedOut: {
        applyAtEnd: { display: 'none' },
        opacity: 0,
      },
      zoomedIn: {
        applyAtStart: { display: 'block' },
        opacity: 1,
      },
    }),
    ZoomImage: posed.img({
      zoomedOut: {
        position: 'static',
        width: 'auto',
        height: 'auto',
        flip: true,
        transition,
      },
      zoomedIn: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        flip: true,
        transition,
      },
    }),
  },
};
</script>

<style>
.zoom-image__img {
  cursor: zoom-in;
  display: block;
  max-width: 100%;
  margin: auto;
  z-index: 100;
  padding: 10px;
}

img.zoomed {
  cursor: zoom-out;
}

.zoom-image__frame {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: none;
  background: rgba(0,0,0,.6);
  transform: translateZ(0);
  z-index: 99;

}
</style>
